export function normalizarAmbiente(valor) {
  return String(valor || "REMOTO").trim().toUpperCase() === "LOCAL"
    ? "LOCAL"
    : "REMOTO";
}

export const AMBIENTE_LOCAL =
  normalizarAmbiente(process.env.REACT_APP_AMBIENTE) === "LOCAL";
export const AMBIENTE_REMOTO = !AMBIENTE_LOCAL;
